export const SET_PAGINATION_REGISTER_MANUAL = 'SET_PAGINATION_REGISTER_MANUAL';
export const CLEAR_PAGINATION_REGISTER_MANUAL = 'CLEAR_PAGINATION_REGISTER_MANUAL';

export const setPaginationRegisterManual = payload => ({
  type: SET_PAGINATION_REGISTER_MANUAL,
  payload,
});

export const clearPaginationRegisterManual = payload => ({
  type: CLEAR_PAGINATION_REGISTER_MANUAL,
  payload,
});
